// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPrefundReturnResponseDto
 */
export interface IPrefundReturnResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IPrefundReturnResponseDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IPrefundReturnResponseDto
     */
    invoice_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IPrefundReturnResponseDto
     */
    org_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IPrefundReturnResponseDto
     */
    plan_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IPrefundReturnResponseDto
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IPrefundReturnResponseDto
     */
    status?: IPrefundReturnResponseDtoStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof IPrefundReturnResponseDto
     */
    created_at?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IPrefundReturnResponseDto
     */
    updated_at?: Date;
}

/**
* @export
* @enum {string}
*/
export enum IPrefundReturnResponseDtoStatusEnum {
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETED = 'COMPLETED',
    APPROVED = 'APPROVED'
}


/**
 * Check if a given object implements the IPrefundReturnResponseDto interface.
 */
export function instanceOfIPrefundReturnResponseDto(value: object): value is IPrefundReturnResponseDto {
    return true;
}

export function IPrefundReturnResponseDtoFromJSON(json: any): IPrefundReturnResponseDto {
    return IPrefundReturnResponseDtoFromJSONTyped(json, false);
}

export function IPrefundReturnResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPrefundReturnResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'invoice_id': json['invoice_id'] == null ? undefined : json['invoice_id'],
        'org_id': json['org_id'] == null ? undefined : json['org_id'],
        'plan_id': json['plan_id'] == null ? undefined : json['plan_id'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'status': json['status'] == null ? undefined : json['status'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'updated_at': json['updated_at'] == null ? undefined : (new Date(json['updated_at'])),
    };
}

export function IPrefundReturnResponseDtoToJSON(json: any): IPrefundReturnResponseDto {
    return IPrefundReturnResponseDtoToJSONTyped(json, false);
}

export function IPrefundReturnResponseDtoToJSONTyped(value?: IPrefundReturnResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'invoice_id': value['invoice_id'],
        'org_id': value['org_id'],
        'plan_id': value['plan_id'],
        'amount': value['amount'],
        'status': value['status'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'updated_at': value['updated_at'] == null ? undefined : ((value['updated_at']).toISOString()),
    };
}

